import { ClientPathSchema } from '@/features/dashboard/client/clientSchema'
import { SimBinding } from '@/features/dashboard/client/sim-binding/SimBiding'
import { usePageTitle } from '@/hooks/usePageTitle'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_dashboard/clients/$clientId/sim-binding',
)({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse
})

function RouteComponent() {
  usePageTitle('SIM紐づけ')
  return <SimBinding />
}